module.exports = __webpack_public_path__ + "static/media/logout.3b9a0e35.svg";